import type { ScenarioResult } from '../../../types';

export function getScenarios(results?: ScenarioResult) {
  const lastIndex = results ? results.dates.length - 1 : 0;

  return [
    {
      name: 'Conservative Strategy',
      description: 'A conservative cash-based strategy that earns a variable interest rate between 2.5 - 4% annually',
      value: results?.risk_free[lastIndex] ?? 0,
      metrics: results ? calculateMetrics(results.risk_free) : { totalReturn: 0, annualizedReturn: 0 },
      color: 'rgb(75, 85, 99)',
      iconColor: 'text-gray-600',
      iconBgColor: 'bg-gray-100',
      bgColor: 'bg-gray-50',
      borderColor: 'border-gray-200',
      riskLevel: 1 as const
    },
    {
      name: 'Low Risk Strategy',
      description: 'A low risk strategy that earns an average annual return forecasted from laddered government securities and treasuries',
      value: results?.low_risk[lastIndex] ?? 0,
      metrics: results ? calculateMetrics(results.low_risk) : { totalReturn: 0, annualizedReturn: 0 },
      color: 'rgb(37, 99, 235)',
      iconColor: 'text-blue-600',
      iconBgColor: 'bg-blue-100',
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200',
      riskLevel: 2 as const
    },
    {
      name: 'Moderate Risk Strategy',
      description: 'A moderate risk strategy that allocates 60% to government securities and treasuries and 40% to highly rated corporate bonds',
      value: results?.moderate_risk[lastIndex] ?? 0,
      metrics: results ? calculateMetrics(results.moderate_risk) : { totalReturn: 0, annualizedReturn: 0 },
      color: 'rgb(22, 163, 74)',
      iconColor: 'text-green-600',
      iconBgColor: 'bg-green-100',
      bgColor: 'bg-green-50',
      borderColor: 'border-green-200',
      riskLevel: 3 as const
    },
    {
      name: 'Higher Risk Strategy',
      description: 'A higher risk strategy is not recommended for most communities. This strategy would allocate 60% to government securities and treasuries, 30% to highly rated corporate bonds and 10% to SPY',
      value: results?.high_risk[lastIndex] ?? 0,
      metrics: results ? calculateMetrics(results.high_risk) : { totalReturn: 0, annualizedReturn: 0 },
      color: 'rgb(234, 88, 12)',
      iconColor: 'text-orange-600',
      iconBgColor: 'bg-orange-100',
      bgColor: 'bg-orange-50',
      borderColor: 'border-orange-200',
      riskLevel: 4 as const
    }
  ];
}

function calculateMetrics(values: number[]) {
  const lastIndex = values.length - 1;
  const totalReturn = (values[lastIndex] - values[0]) / values[0];
  return {
    totalReturn,
    annualizedReturn: Math.pow(1 + totalReturn, 12 / values.length) - 1
  };
}